import React from 'react'
import clsx from 'clsx'

interface Props {
  className?: string
}
const statisticData = [
  {
    stat: '50+',
    title: 'Brilliant Speakers'
  },
  {
    stat: '500k+',
    title: 'Creative Professionals, Leaders and Marketeers'
  },
  {
    stat: '20+',
    title: 'Amazing Conversations'
  }
]

const SolsticeStatistic: React.FC<Props> = ({ className }) => {
  return (
    <div className={clsx(className, 'grid grid-cols-1 sm:grid-cols-3 | gap-8')}>
      {statisticData &&
        statisticData.map((item, key) => {
          return (
            <div className="ml-8" key={key}>
              <p className="text-[40px] lg:text-[55px] | font-semibold ">
                {item?.stat}
              </p>
              <p className="h6 | font-semibold">{item?.title}</p>
            </div>
          )
        })}
    </div>
  )
}
export default SolsticeStatistic
